// Func = limiting Scope for this file
var lastScrollTop = 0;

var scrollParallaxH = [];
var lastScrollLeft = [];

//resize Global variable
//resize sizes
var w=window,
d=document,
e=d.documentElement,
g=d.getElementsByTagName('body')[0],
windowWidth = w.innerWidth||e.clientWidth||g.clientWidth,
windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;




(function(){


	window.onload = function() {
		if(document.getElementById('attractions') || document.getElementsByTagName('body')[0].classList.contains('sitemap')){
			document.getElementById('header').classList.add('down');
		} else {
			scrollW();
			window.addEventListener('scroll', function(){
				scrollW();
			})
		}

		if(document.getElementById('attractions')){
			setTimeout(function(){
				if(document.getElementsByClassName('btn').length > 0){
					convertBtn();
				}
			}, 1000)
		} else {
			if(document.getElementsByClassName('btn').length > 0){
				convertBtn();
			}
		}

	};

	if(document.getElementById('burgerMenu')){
		document.getElementById('burgerMenu').addEventListener('click', function(){
			document.getElementById('menuContainer').classList.add('open')
		})
		document.getElementById('closeMenu').addEventListener('click', function(){
			document.getElementById('menuContainer').classList.remove('open')
		})
	}

	if(document.getElementById('primary-nav')){
		let allLinks = document.getElementById('primary-nav').getElementsByTagName('a');
		let allLinksLength = allLinks.length;
		for(let i=0; i < allLinksLength; i++){
			allLinks[i].addEventListener('click', function(e){
				if(this.nextElementSibling.classList.contains('submenu')){
					let submenuAll = document.getElementsByClassName('submenu');
					for(let h = 0; h < submenuAll.length; h++ ){
						submenuAll[h].classList.remove('open')
					}
					e.preventDefault();
					if(this.nextElementSibling.classList.contains('open')){
						this.nextElementSibling.classList.remove('open')
					} else {
						this.nextElementSibling.classList.add('open')
					}
				}
			})
		}
	}


	//*********    Intersection for parallax effect and other cool animations
	if(!(window.ActiveXObject) && "ActiveXObject" in window){
		//is explorer (-_-)
	}else {
		//parallax
		if(document.getElementsByClassName('parallax-image').length > 0){
			if(window.innerWidth > 1090 ){
				let horizontalOptions = {
					root : null,
					rootMargin : '0px',
					threshold : 0.1
				}
				function handlerParallaxH(entries, observer){
					for(let entry of entries){
						if (entry.isIntersecting) {
							parallaxEffectH(entry.target);
						} else {
							let id_elem = entry.target.getAttribute('parallax-id');
							window.addEventListener('scroll', scrollParallaxH[id_elem])
						}
					}
				}
				let allParallax = document.getElementsByClassName('parallax-image');
				for(let  j = 0; j < allParallax.length; j++ ){
					let observerP = new IntersectionObserver(handlerParallaxH, horizontalOptions)
					observerP.observe(allParallax[j]);
				}

			}
		}
	}


}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if(!document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.add('down');
		}
		
	} else {
		if(document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}


function parallaxEffectH(target){
	let id_elem = target.getAttribute('parallax-id');
	let temp = parseInt(target.getAttribute('data-parallax').split(',')[1]);

	let parallaxFunctionT = function(){
		
		let stp = window.pageYOffset || document.documentElement.scrollTop;

		if(lastScrollLeft[id_elem] === undefined){
			lastScrollLeft[id_elem] = parseInt(stp) - 1;
		}

		
		let direction = target.getAttribute('data-parallax').split(',')[0];
		if (stp > lastScrollLeft[id_elem]){
			
			temp = temp + (direction * 0.4);
			lastScrollLeft[id_elem] = stp - 1;
		} else {
			
			temp = temp - (direction * 0.4);
			lastScrollLeft[id_elem] = stp + 1;
		}
		//if(temp >= 0){
	
			target.setAttribute('style','transform:translateY(' + parseInt(temp) + 'px)');
			target.setAttribute('data-parallax',direction + ',' + parseInt(temp) );
		//}
		
		

	}
	scrollParallaxH[id_elem] = parallaxFunctionT
	window.addEventListener('scroll', scrollParallaxH[id_elem])
}
function convertBtn(){
	
	let allBtn = document.getElementsByClassName('btn');
	let allBtnLength = allBtn.length;
	for(let h = 0; h < allBtnLength; h++){
		let InnerText = '';
		if(!allBtn[h].parentElement.classList.contains('form-module__submit')){ // cms form adds extra span
			InnerText = allBtn[h].innerHTML;
			let compareText = InnerText.toLowerCase();
			allBtn[h].innerHTML = '<span>'+InnerText+'</span>'
			if(compareText.indexOf('order') > -1){
				allBtn[h].classList.add('order-btn')
			}
		}
	}
    
}